import { HeaderInnerState, PositionType } from "../model/header.model";

/**
 * Calculate in which state should be the header
 *
 * @param scrollLimit the y limit from which the header should go from fixed to relative and vice versa
 * @param currentScrollY current y scroll
 * @param lastScrollY the last y scroll (for knowing if we scroll up or down)
 * @param isMenuHeaderActivated tell us if we are in a context where the menu bar can be displayed
 * @returns the new state of the header, fixed or relative, menu-bar only or not
 */
export const getHeaderStateFromScroll = (
    scrollLimit: number,
    currentScrollY: number,
    isScrollingDown: boolean,
    isMenuHeaderActivated: boolean,
): HeaderInnerState => {
    const headerPosition =
        currentScrollY > scrollLimit
            ? PositionType.Fixed
            : PositionType.Relative;

    return {
        headerPosition,
        isOnlyMenuBarDisplayed:
            headerPosition === PositionType.Fixed &&
            isScrollingDown &&
            isMenuHeaderActivated,
    };
};

/**
 * Calculate the current scroll limit from which we should go from a header fixed to relative and vice versa
 */
export const calculateScrollLimit = (
    bannerHeight: number,
    headerHeight: number,
    isScrollingDown: boolean,
    isMenuHeaderActivated: boolean,
): number => {
    // User should always scroll the banners before having header fixed
    let scrollLimit = bannerHeight;
    // if we are scrolling down and the menu is activated, the scroll limit should
    // be between the header-bar and the menu-bar because we only want to keep the menu-bar displayed
    if (isMenuHeaderActivated && isScrollingDown) {
        scrollLimit += headerHeight;
    }

    return scrollLimit;
};

/**
 * Removes a specific query parameter from a given URL string.
 *
 * @param url - The full URL to process.
 * @param queryParameter - The name of the query parameter to remove.
 * @returns The URL without the specified query parameter.
 */
export const removeQueryparamFromUrl = (
    url: string,
    queryParameter: string,
): string => {
    if (!queryParameter || queryParameter.length === 0) {
        return url;
    }
    const [path, query] = url.split("?");
    const searchParameters = new URLSearchParams(query);
    searchParameters.delete(queryParameter);
    const queryString = searchParameters.toString();
    return queryString ? `${path}?${queryString}` : path;
};
